module.exports = __webpack_public_path__ + "static/media/chilli.2e5ad9bd.svg";